import Main from '@jaaluu/Main.vue';
import vuetify from '@jaaluu/vuetify';
import '@shared/scss/all.scss';
import { createApp } from 'vue';
import router from './router';

const app = createApp(Main);
app.use(router);
app.use(vuetify);

router.isReady().then(() => app.mount('#app'));
